import React, { FC, PropsWithChildren, useEffect, useRef } from 'react';
import cx from 'classnames';
import { clamp } from 'lodash';
import { PropsWithClassName } from '@/types/index';
import { useScrollableTimeline } from '@/components/Common/ScrollableTimeline';
import AnimatedSlides from '@/components/Common/AnimatedSlides';
import { detectSafari } from '@/utils/misc';
import * as styles from './MakeItYours360.module.scss';

type Props = PropsWithChildren<
  PropsWithClassName<{
    videoMp4: string;
    videoWebm: string;
  }>
>;

const MakeItYours360: FC<Props> = ({ className, videoMp4, videoWebm, children }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const { progress, progressBetween } = useScrollableTimeline();
  const isSafari = detectSafari();

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      const progress = progressBetween([0, 0.75]);
      const currentTime = clamp(progress * video.duration, 0, video.duration);
      if (isFinite(currentTime)) {
        video.currentTime = currentTime;
      }
    }
  }, [progressBetween]);

  const video = isSafari ? videoMp4 : videoWebm;

  return (
    <div className={styles.main}>
      <div
        className={cx(styles.container, className)}
        style={
          {
            '--progress': `${progress}`,
          } as React.CSSProperties
        }
      >
        <video
          ref={videoRef}
          src={video}
          playsInline
          preload="auto"
          controls={false}
          className={styles.video}
        />
        <AnimatedSlides
          className={styles.slides}
          activeIndex={Math.round(progressBetween([0.6, 1]))}
          slides={[<></>, <div className={styles.slide}>{children}</div>]}
        />
      </div>
    </div>
  );
};

export default MakeItYours360;
